import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils/request';

export const uploadAttachment = (url: string, data: FormData) => performRequest({
    method: ERequestType.POST,
    url,
    headers: {'Content-Type': 'multipart/form-data'},
    data,
});
